<template>
    <div>
        <el-drawer
                size="50%"
                title="更新任务"
                :before-close="handleClose"
                :visible.sync="showModal"
                direction="rtl"
                custom-class="demo-drawer"
                ref="drawer"
        >
            <div class="demo-drawer__content">
                <el-form :model="form" :rules="rules" size="medium"  ref="forms" label-suffix="：" class="form">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="执行器" prop="region" :label-width="formLabelWidth">
                                <el-select v-model="form.region" placeholder="请选择执行器">
                                    <el-option label="区域一" value="shanghai"></el-option>
                                    <el-option label="区域二" value="beijing"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="任务描述" prop="name" :label-width="formLabelWidth">
                                <el-input v-model="form.name" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="路由策略" prop="region" :label-width="formLabelWidth">
                                <el-select v-model="form.region" placeholder="请选择执行器">
                                    <el-option label="区域一" value="shanghai"></el-option>
                                    <el-option label="区域二" value="beijing"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Cron" prop="name" :label-width="formLabelWidth">
                                <el-input v-model="form.name" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="运行模式" prop="region" :label-width="formLabelWidth">
                                <el-select v-model="form.region" placeholder="请选择执行器">
                                    <el-option label="区域一" value="shanghai"></el-option>
                                    <el-option label="区域二" value="beijing"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="JobHandler" prop="name" :label-width="formLabelWidth">
                                <el-input v-model="form.name" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="阻塞处理策略" prop="region" :label-width="formLabelWidth">
                                <el-select v-model="form.region" placeholder="请选择执行器">
                                    <el-option label="区域一" value="shanghai"></el-option>
                                    <el-option label="区域二" value="beijing"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="子任务ID" prop="name" :label-width="formLabelWidth">
                                <el-input v-model="form.name" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="任务超时时间" prop="region" :label-width="formLabelWidth">
                                <el-select v-model="form.region" placeholder="请选择执行器">
                                    <el-option label="区域一" value="shanghai"></el-option>
                                    <el-option label="区域二" value="beijing"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="失败重连次数" prop="name" :label-width="formLabelWidth">
                                <el-input v-model="form.name" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="负责人" prop="region" :label-width="formLabelWidth">
                                <el-select v-model="form.region" prop="region" placeholder="请选择执行器">
                                    <el-option label="区域一" value="shanghai"></el-option>
                                    <el-option label="区域二" value="beijing"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="报警邮件" prop="name" :label-width="formLabelWidth">
                                <el-input v-model="form.name" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-form-item label="任务参数" prop="name" :label-width="formLabelWidth">
                            <el-input type="textarea" :rows="5" placeholder="请输入任务参数" v-model="form.desc"></el-input>
                        </el-form-item>
                    </el-row>
                </el-form>
                <div class="demo-drawer__footer">
                    <el-button @click="cancelForm">取 消</el-button>
                    <el-button type="primary" @click="$refs.drawer.closeDrawer()" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
                </div>
            </div>
        </el-drawer>

    </div>
</template>

<script>
    export default {
        data(){
            return{
                showModal:false,
                formLabelWidth:'130px',
                form:{
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                },
                rules:{
                    name: [
                        { required: true, message: '请输入', trigger: 'blur' },
                    ],
                    region: [
                        { required: true, message: '请选择', trigger: 'change' }
                    ],
                }
            }
        },
        methods:{
            handleClose(){
                this.showModal = false
            },
            cancelForm(){
                this.showModal = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    .demo-drawer__content{
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 20px;

    }
    .form{
        flex: 1;
        .el-input,.el-select{
            width: 100%!important;
        }
    }
    .demo-drawer__footer{
        display: flex;
    }
    .demo-drawer__footer button{
        flex: 1;
    }
</style>
